import { createControlField } from '@lib/common';
import { FormControl, InputLabel, Select, FormHelperText } from '@material-ui/core';
import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';

const StatusAutoComplete = ({ value, onChange }) => {
  const form = useFormContext();
  return (
    <Styles>
      <FormControl variant="outlined" size="small" fullWidth>
        <InputLabel id="genre_category_label" shrink>Genres Category</InputLabel>
        <Select
          labelId="genre_category_label"
          id="genre_category"
          name="genre_category"
          inputRef={form.register}
          native
          label="Genres Category"
          defaultValue="Genres Category">
          <option value="scripted">Scripted</option>
          <option value="unscripted">Unscripted</option>
        </Select>
        <FormHelperText>Genres Category</FormHelperText>
      </FormControl>
      </Styles>
  );
};

const Styles = styled.div`
  .MuiInputLabel-shrink {
    transform: translate(14px, -6px) scale(0.75)
  }
  .MuiChip-deleteIcon {
    color: white;
  }
  legend {
    max-width: 1000px;
  }
`;

export const GenresTypeField = createControlField(StatusAutoComplete, []);
